import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { Emoji } from '../emoji-picker/emoji';
import { EmojiPickerService } from '../emoji-picker/emoji-picker.service';
import * as Utils from './utils';
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'contenteditable',
  template: `
    <div class="content-editable-container"
        [ngClass]="{'single-line': singleLine, 'height-fixed': isHigher}">
      <div class="scroll-bar" style="height: 100%;overflow-y: overlay;overflow-x:hidden">
        <div class="content-editable-input"
            #editor
            style="position: relative"
            contenteditable="true"
            (input)="onChange()"
            (compositionstart)="startInputZh()"
            (compositionend)="stopInputZh()"
            (keyup)="onKeyUp($event)"
            (focus)="onFocus($event)"
            (blur)="onBlur($event)"
            (drop)="onDrop($event)"
            (paste)="onPaste($event)"
            (keydown)="onKeyDown($event)">
        </div>

        <div class="content-editable-input-placeholder"
            (click)="editor.focus()"
            *ngIf="!!placeholder && !(value && value.length) && !focused">{{ placeholder }}
        </div>
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: []
})
export class ContenteditableComponent implements OnInit, OnChanges {
  @Input() placeholder: string;
  @Input() singleLine = true;
  @Input() value: string;
  @ViewChild('editor') editorRef: ElementRef;
  @Output()
  ValueChangedEvent = new EventEmitter();

  @Output()
  SendEvent = new EventEmitter();

  focused = false;
  savedSelection;
  subscriptions: Array<Subscription> = [];

  isHigher = false;
  lastHeight = 0;

  isInputZh = false;

  @Input() clearEditorFlag = false;
  @Output() onClearedEvent = new EventEmitter();
  @Output() scrollEndEvent = new EventEmitter();
  constructor(
    private _emojiPickerService: EmojiPickerService,
  ) { }

  ngOnInit() {
    this.subscriptions.push(
      this._emojiPickerService.emojiSource$.subscribe(emoji => {
        if (emoji && emoji.hasOwnProperty('id')) {
          Utils.restoreSelection(this.savedSelection);
          this.pasteHtmlAtCaret(Object.assign(new Emoji(), emoji).html, false);
          this._emojiPickerService.selectEmoji(null);
          this.value = this.editorRef.nativeElement.innerHTML.replace(/<div class=\"ps__rail.*<\/div>/g, "");
          this.onChange();
        }
      })
    );
  }

  startInputZh() {
    this.isInputZh = true;
  }

  // 间接输入时，事件的触发顺序为： compositionStart, compositionUpdate, input, compositionEnd
  // 在iOS中，需要在间接输入结束后，手动检查input.value的值和调用input事件，以避免输入为拼音的情况
  stopInputZh() {
    this.isInputZh = false;
    this.value = this.editorRef.nativeElement.innerHTML.replace(/<div class=\"ps__rail.*<\/div>/g, "");
    this.onChange();
  }

  onChange() {
    // console.log(this.isInputZh);
    if (this.isInputZh) {
      return;
    }
    this.ValueChangedEvent.emit(this.value);
    this.changeInputHeight();
  }

  onKeyDown(event: any) {
    if (event.key === 'Enter' && event.ctrlKey) {
      document.execCommand('insertHTML', false, '<br><br>');
      // this.scrollToBottom();
    } else if (event.key === 'Enter' && event.keyCode === 13) {
      event.preventDefault();
      this.send();
    }
  }

  onKeyUp(event: any) {
    this.value = this.editorRef.nativeElement.innerHTML.replace(/<div class=\"ps__rail.*<\/div>/g, "");
    if (event.key === 'Enter' && event.keyCode === 13) {
      event.preventDefault();
      return;
    }
    this.onChange();
  }

  onFocus(event) {
    this.focused = true;
  }

  onBlur(event) {
    this.focused = false;
    this.onTextAreaBlur();
  }

  onTextAreaBlur() {
    this.savedSelection = Utils.saveSelection();
  }

  send() {
    if (!this.value) {
      this.value = '';
    }
    if (this.value.trim() === '') {
      return;
    }

    this.SendEvent.emit();
    this.value = '';
    this.editorRef.nativeElement.innerHTML = "";
    this.ValueChangedEvent.emit(this.value);
    this.isHigher = false;
    this.lastHeight = 0;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['clearEditorFlag']) {
      if (changes['clearEditorFlag'].previousValue !== undefined && changes['clearEditorFlag'].currentValue) {
        this.clearEditor();
      }
      setTimeout(()=> {
        this.onClearedEvent.emit();
      }, 50);
    }
  }

  clearEditor() {
    if (this.editorRef && !!this.value) {
      this.value = '';
      this.editorRef.nativeElement.innerHTML = "";
      this.ValueChangedEvent.emit(this.value);
      // console.log('cleared');
    };
  }

  pasteHtmlAtCaret(html, selectPastedContent) {
    this.editorRef.nativeElement.focus();
    let sel, range;
    if (window.getSelection) {
      sel = window.getSelection();
      if (sel.getRangeAt && sel.rangeCount) {
        range = sel.getRangeAt(0);
        if (range.commonAncestorContainer.parentNode === this.editorRef.nativeElement
          || range.commonAncestorContainer === this.editorRef.nativeElement) {
          range.deleteContents();
          const el = document.createElement('div');
          el.innerHTML = html;
          const frag = document.createDocumentFragment();
          let node, lastNode;
          while ((node = el.firstChild)) {
            lastNode = frag.appendChild(node);
          }
          const firstNode = frag.firstChild;
          range.insertNode(frag);
          if (lastNode) {
            range = range.cloneRange();
            range.setStartAfter(lastNode);
            if (selectPastedContent) {
              range.setStartBefore(firstNode);
            } else {
              range.collapse(true);
            }
            sel.removeAllRanges();
            sel.addRange(range);
          }
          return;
        }
      }
    }
  }
  onDrop(event) {
    event.preventDefault();
  }
  onPaste(event) {
    event.preventDefault();
    this.value = (event.originalEvent || event).clipboardData.getData('text/plain')
      .replace(/&nbsp;/gi, '')
      .replace(/(?:(\r\n)+|\r+|\n+)/g, '<br>') // 换行符
      .trim();
    document.execCommand("insertHTML", false, this.value);
  }
  scrollToBottom() {
    // this.ps.directiveRef.scrollToBottom(0, 0);
    this.scrollEndEvent.emit();
  }
  changeInputHeight() {
    // console.log(this.editorRef);
    if (this.editorRef.nativeElement.offsetHeight >= 96) {
      this.isHigher = true;
    } else {
      this.isHigher = false;
    }
    setTimeout(() => {
      if (this.editorRef.nativeElement.offsetHeight > this.lastHeight) {
        this.scrollToBottom();
      }
      this.lastHeight = this.editorRef.nativeElement.offsetHeight;
    }, 10);
  }
}
